module.exports = __webpack_public_path__ + "static/media/Github.a17808bb.svg";